import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import BillingAndAddonsLayer from "../components/BillingAndAddonsLayer";

const BillingAndAddonsPage = () => {
    return (
        <>
        {/* Master layout */}
        <MasterLayout>
            {/* Breadcrumb */}
            <Breadcrumb title="Billing & Addons" />

            {/* Billing and Addons content goes here */}
            <BillingAndAddonsLayer/>
        </MasterLayout>
        </>
    );
}

export default BillingAndAddonsPage